export const COOKIE_POLICY_PATH = '/cookie_policy';
